import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { accentuate } from '../'
import { Section, Heading, Instructions, ExternalLink, ExternalLinkBlock } from '../s'
import Paragraph from 'components/typography/paragraph'

const TripletexHowToUse = ({ data }) => {
    const { formatMessage } = useIntl()

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_heading_how_to_use"
                    defaultMessage="How to use" />
            </Heading>
            <Paragraph>
                <FormattedMessage
                    id="integration_preamble_how_to_use"
                    defaultMessage="Get started quickly by following these steps:" />
            </Paragraph>
            <Instructions instructions={[
                {
                    text: formatMessage({
                        id: 'integration_tripletex_instruction_connect',
                        defaultMessage: 'To get started, you will need an <accent>Employee Token</accent> provided by Tripletex. Read more about how to get it in our knowledge base.'
                    }, {
                        accent: accentuate,
                        link: chunks => (
                            <ExternalLink href={data.knowledgebaseUrl}>
                                {chunks}
                            </ExternalLink>
                        )
                    })
                },
                {
                    text: formatMessage({
                        id: 'integration_tripletex_instruction_setup',
                        defaultMessage: 'Once you have the Employee token you can <accent>Set up</accent> the integration in Huma.'
                    }, { accent: accentuate })
                },
                {
                    text: formatMessage({
                        id: 'integration_tripletex_instruction_accept_terms',
                        defaultMessage: 'Accept the terms and go through the integration settings.'
                    })
                },
                {
                    text: formatMessage({
                        id: 'integration_tripletex_instruction_sync_users',
                        defaultMessage: 'To <accent>activate</accent> the integration you need to do an initial synchronization of users.'
                    }, { accent: accentuate })
                }
            ]} />
            <ExternalLinkBlock href={data.knowledgebaseUrl}>
                <FormattedMessage
                    id="integration_tripletex_link_knowledgebase"
                    defaultMessage="Using the Tripletex integration" />
            </ExternalLinkBlock>
        </Section>
    )
}

export default TripletexHowToUse